import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_35ea3ec6 from 'nuxt_plugin_plugin_35ea3ec6' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtplugin27f4d1b1_666771e5 from 'nuxt_plugin_nuxtplugin27f4d1b1_666771e5' // Source: ./nuxt.plugin.27f4d1b1.js (mode: 'server')
import nuxt_plugin_vuescrollto_57ff8f15 from 'nuxt_plugin_vuescrollto_57ff8f15' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_36d8841c from 'nuxt_plugin_cookieuniversalnuxt_36d8841c' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_a477cf72 from 'nuxt_plugin_pluginutils_a477cf72' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_386b715b from 'nuxt_plugin_pluginseo_386b715b' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_031fafd2 from 'nuxt_plugin_pluginrouting_031fafd2' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_dedcc646 from 'nuxt_plugin_pluginmain_dedcc646' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_9160bf6c from 'nuxt_plugin_gtm_9160bf6c' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_distplugin57527824_7dfd3bf0 from 'nuxt_plugin_distplugin57527824_7dfd3bf0' // Source: ./dist.plugin.57527824.mjs (mode: 'all')
import nuxt_plugin_image_6e05496f from 'nuxt_plugin_image_6e05496f' // Source: ./image.js (mode: 'all')
import nuxt_plugin_magentoplugin69f20585_41508b0b from 'nuxt_plugin_magentoplugin69f20585_41508b0b' // Source: ./magento.plugin.69f20585.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting38f658eb_5082752e from 'nuxt_plugin_pluginse2etesting38f658eb_5082752e' // Source: ./plugins.e2e-testing.38f658eb.js (mode: 'all')
import nuxt_plugin_deviceplugin_398c2fff from 'nuxt_plugin_deviceplugin_398c2fff' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_3e6d7490 from 'nuxt_plugin_workbox_3e6d7490' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_a8dda8ba from 'nuxt_plugin_metaplugin_a8dda8ba' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_9f8e5dd2 from 'nuxt_plugin_iconplugin_9f8e5dd2' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_vimeoplayer_c28cd600 from 'nuxt_plugin_vimeoplayer_c28cd600' // Source: ../plugins/vimeo-player (mode: 'all')
import nuxt_plugin_tooltip_ba49f866 from 'nuxt_plugin_tooltip_ba49f866' // Source: ../plugins/tooltip (mode: 'all')
import nuxt_plugin_masonry_18e5320f from 'nuxt_plugin_masonry_18e5320f' // Source: ../plugins/masonry (mode: 'all')
import nuxt_plugin_gtag_6a810249 from 'nuxt_plugin_gtag_6a810249' // Source: ../plugins/gtag (mode: 'all')
import nuxt_plugin_vselect_294cd8ae from 'nuxt_plugin_vselect_294cd8ae' // Source: ../plugins/v-select (mode: 'all')
import nuxt_plugin_svgimage_f07eec08 from 'nuxt_plugin_svgimage_f07eec08' // Source: ../plugins/svg-image (mode: 'all')
import nuxt_plugin_vuebar_163abb16 from 'nuxt_plugin_vuebar_163abb16' // Source: ../plugins/vue-bar (mode: 'all')
import nuxt_plugin_lazyhydrate_1fab4df0 from 'nuxt_plugin_lazyhydrate_1fab4df0' // Source: ../plugins/lazy-hydrate (mode: 'all')
import nuxt_plugin_skeletonloader_66602946 from 'nuxt_plugin_skeletonloader_66602946' // Source: ../plugins/skeleton-loader (mode: 'all')
import nuxt_plugin_vueobservevisibility_2d7eef00 from 'nuxt_plugin_vueobservevisibility_2d7eef00' // Source: ../plugins/vue-observe-visibility (mode: 'all')
import nuxt_plugin_cookielaw_2c1e0eaf from 'nuxt_plugin_cookielaw_2c1e0eaf' // Source: ../plugins/cookie-law (mode: 'client')
import nuxt_plugin_meta_74bf1358 from 'nuxt_plugin_meta_74bf1358' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Vizulo","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"We are an energy-efficient lighting solution company specializing in street, territory, commercial, industrial, and architectural LED lighting. VIZULO stands for beautiful product design, high technical parameters, and excellent quality. With great new and existing products and ongoing projects, the company keeps expanding its business and create new solutions for municipalities and entrepreneurs to create a better and safer lighting for people and the environment."},{"hid":"og:title","property":"og:title","content":"Vizulo"},{"hid":"og:description","property":"og:description","content":"We are an energy-efficient lighting solution company specializing in street, territory, commercial, industrial, and architectural LED lighting. VIZULO stands for beautiful product design, high technical parameters, and excellent quality. With great new and existing products and ongoing projects, the company keeps expanding its business and create new solutions for municipalities and entrepreneurs to create a better and safer lighting for people and the environment."},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fvizulo.com\u002Fvizulo-logo.png"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","property":"og:site_name","content":"Vizulo"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fvizulo.com\u002Fen"},{"hid":"apple-mobile-web-app-title","property":"apple-mobile-web-app-title","content":"Vizulo"},{"hid":"generator","property":"generator","content":"Vizulo"},{"name":"robots","content":"index,follow"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"\u002Fcss\u002Fgrid.css"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('G-VTEE7BFQ3C')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=G-VTEE7BFQ3C&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_35ea3ec6 === 'function') {
    await nuxt_plugin_plugin_35ea3ec6(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin27f4d1b1_666771e5 === 'function') {
    await nuxt_plugin_nuxtplugin27f4d1b1_666771e5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_57ff8f15 === 'function') {
    await nuxt_plugin_vuescrollto_57ff8f15(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_36d8841c === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_36d8841c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_a477cf72 === 'function') {
    await nuxt_plugin_pluginutils_a477cf72(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_386b715b === 'function') {
    await nuxt_plugin_pluginseo_386b715b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_031fafd2 === 'function') {
    await nuxt_plugin_pluginrouting_031fafd2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_dedcc646 === 'function') {
    await nuxt_plugin_pluginmain_dedcc646(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_9160bf6c === 'function') {
    await nuxt_plugin_gtm_9160bf6c(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin57527824_7dfd3bf0 === 'function') {
    await nuxt_plugin_distplugin57527824_7dfd3bf0(app.context, inject)
  }

  if (typeof nuxt_plugin_image_6e05496f === 'function') {
    await nuxt_plugin_image_6e05496f(app.context, inject)
  }

  if (typeof nuxt_plugin_magentoplugin69f20585_41508b0b === 'function') {
    await nuxt_plugin_magentoplugin69f20585_41508b0b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting38f658eb_5082752e === 'function') {
    await nuxt_plugin_pluginse2etesting38f658eb_5082752e(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_398c2fff === 'function') {
    await nuxt_plugin_deviceplugin_398c2fff(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_3e6d7490 === 'function') {
    await nuxt_plugin_workbox_3e6d7490(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_a8dda8ba === 'function') {
    await nuxt_plugin_metaplugin_a8dda8ba(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_9f8e5dd2 === 'function') {
    await nuxt_plugin_iconplugin_9f8e5dd2(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_vimeoplayer_c28cd600 === 'function') {
    await nuxt_plugin_vimeoplayer_c28cd600(app.context, inject)
  }

  if (typeof nuxt_plugin_tooltip_ba49f866 === 'function') {
    await nuxt_plugin_tooltip_ba49f866(app.context, inject)
  }

  if (typeof nuxt_plugin_masonry_18e5320f === 'function') {
    await nuxt_plugin_masonry_18e5320f(app.context, inject)
  }

  if (typeof nuxt_plugin_gtag_6a810249 === 'function') {
    await nuxt_plugin_gtag_6a810249(app.context, inject)
  }

  if (typeof nuxt_plugin_vselect_294cd8ae === 'function') {
    await nuxt_plugin_vselect_294cd8ae(app.context, inject)
  }

  if (typeof nuxt_plugin_svgimage_f07eec08 === 'function') {
    await nuxt_plugin_svgimage_f07eec08(app.context, inject)
  }

  if (typeof nuxt_plugin_vuebar_163abb16 === 'function') {
    await nuxt_plugin_vuebar_163abb16(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyhydrate_1fab4df0 === 'function') {
    await nuxt_plugin_lazyhydrate_1fab4df0(app.context, inject)
  }

  if (typeof nuxt_plugin_skeletonloader_66602946 === 'function') {
    await nuxt_plugin_skeletonloader_66602946(app.context, inject)
  }

  if (typeof nuxt_plugin_vueobservevisibility_2d7eef00 === 'function') {
    await nuxt_plugin_vueobservevisibility_2d7eef00(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookielaw_2c1e0eaf === 'function') {
    await nuxt_plugin_cookielaw_2c1e0eaf(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_74bf1358 === 'function') {
    await nuxt_plugin_meta_74bf1358(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
